module.exports = __webpack_public_path__ + "static/img/20180414165914.a23668e0.jpg";